import React, { useState } from "react";
import DynamicSelect from "../../shared/DynamicSelect";
import RealignDenominationView from "./RealignDenominationView";
import { getDenominationStyles } from "../../../styles/banknotes-styles";

const denominationStyles = getDenominationStyles();

const RealignItem = (props) => {

    const { index, item, loadCurrencyDenominations, currencies, editingRow, removeItem, enableRemove, showStock, validateCurrency } = props;

    const [currency, setCurrency] = useState('');    
    const [refresh, setRefresh] = useState(false);

    const onSelectCurrency = (event, index) => {
        let value = event.value;
        if(value)
        {
            if(!validateCurrency(value)){
                setCurrency(value);
                loadCurrencyDenominations(value, index);
                setRefresh(!refresh);
            }
        }
    };

    let denominationView = [];

    let itemDenominations = item.Denominations || [];

    if (itemDenominations && Array.isArray(itemDenominations)) {
        denominationView.push(
            <RealignDenominationView
                key={`recon-row-${index}`}
                rowId={index}
                denominations={itemDenominations}
                currency={currency}
                item={item}
                currencies={currencies}
                onSelectCurrency={onSelectCurrency}
                removeItem={removeItem}
                enableRemove={enableRemove}
                showStock={showStock}
            />
        );
    }

    return (
        <>
            <div style={{ display: "flex", direction: "row", alignItems: "center", gap: "2rem", width: '75%',  }}>
                <>{editingRow && item.CurrencyID !== '' ?
                    <div style={denominationStyles.processingRowHeaderCurrency}>{item.CurrencyID}</div> :
                    <DynamicSelect
                        id={`s-currency-${index}`}
                        className={"uk-select"}
                        placeholder="Select a currency"
                        placeholderValue=""
                        data={currencies}
                        objValue={{ value: currency }}
                        getValue={(e)=>onSelectCurrency(e,index)}
                    />}
                </>
                <>
                    {denominationView}
                </>
            </div>
            <hr style={{ marginTop: '0.5rem' }} />
        </>
    );
};

export default RealignItem